export default __webpack_public_path__ + "static/media/m_foodieBooster06.e44ef312.png";